import { ActionReducerMapBuilder, createSlice } from '@reduxjs/toolkit';
import {
  getAdminRecentBlogs,
  toggleBlogActiveStatus,
  toggleBlogAllowedStatus,
} from '../actions/adminActions';
import { getPageFromUrl } from '../../../utils/paginationUtil';

const initialState: AdminBlogListStateType = {
  blogs: [],
  isLoading: false,
  errorMessage: '',
  paginator: {
    count: 0,
    next: null,
    previous: null,
    currentPage: 1,
  },
};

const adminRecentBlogsSlice = createSlice({
  name: 'adminRecentBlogs',
  initialState,
  reducers: {
    clearAdminRecentBlogs: () => initialState,
  },
  extraReducers: (builder: ActionReducerMapBuilder<AdminBlogListStateType>) => {
    builder.addCase(getAdminRecentBlogs.pending, state => {
      state.isLoading = true;
      state.errorMessage = '';
    });

    builder.addCase(getAdminRecentBlogs.fulfilled, (state, action) => {
      state.isLoading = false;
      state.blogs = action.payload.results;
      state.paginator = {
        count: action.payload.count,
        next: getPageFromUrl(action.payload.next),
        previous: getPageFromUrl(action.payload.previous),
        currentPage: action.meta.arg.page || 1,
      };
    });

    builder.addCase(getAdminRecentBlogs.rejected, (state, action) => {
      state.isLoading = false;
      state.errorMessage =
        action.payload?.detail || 'Failed to load recent blogs';
    });

    // The toggle response doesn't include the blog id, so find it via the
    // id the thunk was called with (action.meta.arg) instead.
    builder.addCase(toggleBlogActiveStatus.fulfilled, (state, action) => {
      const blog = state.blogs.find(b => b.id === action.meta.arg);
      if (blog) {
        blog.is_active = action.payload.is_active;
        blog.is_allowed = action.payload.is_allowed;
      }
    });

    builder.addCase(toggleBlogAllowedStatus.fulfilled, (state, action) => {
      const blog = state.blogs.find(b => b.id === action.meta.arg);
      if (blog) {
        blog.is_active = action.payload.is_active;
        blog.is_allowed = action.payload.is_allowed;
      }
    });

    builder.addCase(toggleBlogActiveStatus.rejected, (state, action) => {
      state.errorMessage =
        (action.payload as { detail?: string } | undefined)?.detail ||
        'Failed to update active status';
    });

    builder.addCase(toggleBlogAllowedStatus.rejected, (state, action) => {
      state.errorMessage =
        (action.payload as { detail?: string } | undefined)?.detail ||
        'Failed to update allowed status';
    });
  },
});

export const { clearAdminRecentBlogs } = adminRecentBlogsSlice.actions;
export default adminRecentBlogsSlice.reducer;
